export enum ReservationHour {
  OPENING = '08:00:00+01',
  CLOSURE = '19:00:00+01',
  SATURDAY_CLOSURE = '15:00:00+01',
}
